import {
  jb_navigation_tags_css_default
} from "./chunk.7UF75XHK.js";
import {
  Spaceable
} from "./chunk.P6YYTXAQ.js";
import {
  to
} from "./chunk.3OP6Y2IJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  respondTo
} from "./chunk.VQ52AZAH.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  e,
  n,
  r as r2
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-navigation-tags/jb-navigation-tags.ts
var JbNavigationTags = class extends Spaceable(r) {
  constructor() {
    super(...arguments);
    this._showButton = false;
  }
  firstUpdated() {
    const relatedTags = this.renderRoot.querySelectorAll(".navigation-tags.with-underline .list .list-item");
    relatedTags.forEach((el) => {
      el.addEventListener("click", () => {
        const parent = el.parentNode;
        const active = parent?.querySelector(".list-item.active");
        if (active) active.classList.remove("active");
        el.classList.add("active");
      });
    });
    window.addEventListener("resize", () => {
      this._calculateShowButton();
    });
    setTimeout(() => {
      this._calculateShowButton();
    }, 0);
  }
  _calculateShowButton() {
    const element = this._list.firstElementChild;
    const styles = window.getComputedStyle(element);
    const heightWithMargin = element.offsetHeight + parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    const actualHeight = this._list.scrollHeight - 30;
    if (respondTo({ xs: "mobile", sm: "desktop" }) === "mobile") {
      if (actualHeight >= heightWithMargin * 4) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    } else {
      if (actualHeight >= heightWithMargin * 2) {
        this._showButton = true;
      } else {
        this._showButton = false;
      }
    }
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 12, type: "navigation-tags" };
  }
  _renderItem(item) {
    return ke`<li
      class="list-item animate-left-bottom ${item.tag === this.activeItem ? "active" : ""}"
      data-search-action-url=${to(item.searchAction)}
      data-search-suggest-url=${to(item.suggestUrl)}
    >
      <a
        href=${to(item.link.href)}
        data-tag=${item.tag}
        @click=${this._trackClicks}
        >${item.tag}</a
      >
    </li>`;
  }
  _trackClicks(evt) {
    const eventTarget = evt.composedPath()[0];
    const tag = eventTarget.dataset.tag ?? evt.detail.label;
    const url = eventTarget.href ?? evt.detail.newValue;
    this.dispatchEvent(
      new CustomEvent("jb-navigation-tags:filter", {
        detail: {
          tag,
          url
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`<nav
      role="navigation"
      aria-label="Tag navigation"
      class="navigation-tags ${this.type}"
    >
      <input
        type="checkbox"
        id="checkbox"
        @change=${() => this.requestUpdate()}
      />
      ${this.heading ? ke`<jb-section-headline .headline=${this.heading}></jb-section-headline>` : D}
      <ul class="list">
        ${this.items.map((item) => this._renderItem(item))}
      </ul>
      ${this._showButton ? ke` <div class="title-wrapper">
            <label
              for="checkbox"
              data-open="${this.toOpenText}"
              data-close="${this.toCloseText}"
            >
              <jb-chevron-icon direction=${this._input?.checked ? "up" : "down"}></jb-chevron-icon>
            </label>
          </div>` : D}
    </nav>`;
  }
};
JbNavigationTags.styles = jb_navigation_tags_css_default;
__decorateClass([
  n()
], JbNavigationTags.prototype, "activeItem", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "heading", 2);
__decorateClass([
  n({ type: Array })
], JbNavigationTags.prototype, "items", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toCloseText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "toOpenText", 2);
__decorateClass([
  n()
], JbNavigationTags.prototype, "type", 2);
__decorateClass([
  e("input")
], JbNavigationTags.prototype, "_input", 2);
__decorateClass([
  e(".list")
], JbNavigationTags.prototype, "_list", 2);
__decorateClass([
  r2()
], JbNavigationTags.prototype, "_showButton", 2);
JbNavigationTags = __decorateClass([
  customElement("jb-navigation-tags")
], JbNavigationTags);

export {
  JbNavigationTags
};
